import React, { useEffect, useRef } from 'react';
import { Stack, FormControl, FormLabel, TextField, MenuItem } from '@mui/material';
import Kartu from '../../../assets/images/kartu.jpg';

const Step3Form = ({ formData, handleChange }: { formData: any, handleChange: any }) => {
  const isNonKambing = formData.pilih_paket === 'nonkambing';
  const isBox = formData.paket_katalog?.trim() === 'Box Cetak' || formData.paket_katalog?.trim() === 'Box Sebar';

  const prevPaketKatalog = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (isBox) {
      if (formData.souvenir !== '') {
        handleChange({ target: { name: 'souvenir', value: '' } });
      }
      if (formData.kartu !== '') {
        handleChange({ target: { name: 'kartu', value: '' } });
      }
    }
    // Tidak perlu else, biarkan user mengisi jika bukan Box
    // Tidak perlu cek prevPaketKatalog lagi
  }, [isBox, formData.souvenir, formData.kartu, handleChange]);
  return (
    <Stack spacing={2}>
      {/* Hanya tampilkan Penyembelihan dan Souvenir jika bukan nonkambing */}
      {!isNonKambing && (
        <>
          <FormControl>
            <FormLabel htmlFor="penyembelihan" sx={{ textAlign: 'left' }}>Penyembelihan</FormLabel>
            <TextField
              select
              value={formData.penyembelihan}
              onChange={handleChange}
              id="penyembelihan"
              name="penyembelihan"
              placeholder="Pilih Penyembelihan"
              required
              fullWidth
              variant="outlined"
            >
              <MenuItem value="" disabled>Pilih Proses Penyembelihan</MenuItem>
              <MenuItem value="Video Call">Video Call</MenuItem>
              <MenuItem value="Kirim Video">Kirim Video</MenuItem>
            </TextField>
          </FormControl>
          {!isBox && (
            <FormControl>
              <FormLabel htmlFor="souvenir" sx={{ textAlign: 'left' }}>Pilih Souvenir</FormLabel>
              <TextField
                select
                value={formData.souvenir}
                onChange={handleChange}
                id="souvenir"
                name="souvenir"
                placeholder="Pilih Souvenir"
                required
                fullWidth
                variant="outlined"
              >
                <MenuItem value="" disabled>Pilih Proses Souvenir</MenuItem>
                <MenuItem value="Boneka Qiped">Boneka Qiped</MenuItem>
              </TextField>
            </FormControl>
          )}

          {!isBox && (
            <>
              <FormControl>
                <FormLabel htmlFor="kartu" sx={{ textAlign: 'left' }}>Kartu Ucapan</FormLabel>
                <TextField
                  select
                  value={formData.kartu}
                  onChange={handleChange}
                  id="kartu"
                  name="kartu"
                  placeholder="Pilih Kartu Ucapan"
                  required
                  fullWidth
                  variant="outlined"
                >
                  <MenuItem value="" disabled>Pilih Kartu Ucapan</MenuItem>
                  {Array.from({ length: 12 }, (_, i) => (
                    <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>
                  ))}
                </TextField>
              </FormControl>

              <img src={Kartu} alt="Pilihan Kartu" style={{ width: '300px', height: 'auto', alignSelf: 'center' }} />
            </>
          )}
          <FormControl>
            <FormLabel htmlFor="pakaiFoto" sx={{ textAlign: 'left' }}>Pakai Foto</FormLabel>
            <TextField
              select
              value={formData.pakaiFoto}
              onChange={handleChange}
              id="pakaiFoto"
              name="pakaiFoto"
              placeholder="Pilih Pakai Foto"
              required
              fullWidth
              variant="outlined"
            >
              <MenuItem value="" disabled>Pilih Pakai Foto</MenuItem>
              <MenuItem value="Ya">Ya</MenuItem>
              <MenuItem value="Tidak">Tidak</MenuItem>
            </TextField>
          </FormControl>

        </>
      )}

      {/* Kartu Ucapan tetap ditampilkan selalu */}

    </Stack>
  );
};

export default Step3Form;
